import { useEffect } from 'react';

import type { ArtificialCustomEventUnion, ArtificialOperation, EventOfType, GetEventValue } from './types';

const isArtificialCustomEvent = (event: Event): event is ArtificialCustomEventUnion => {
  return 'detail' in event;
};

export const useCustomEventListener = <Operation extends ArtificialOperation>(
  name: Operation,
  callback: (value: GetEventValue<EventOfType<Operation>>) => void,
) => {
  // Re-subscribe when name/callback change so the listener always fires the latest closure.
  useEffect(() => {
    const handler = (event: Event) => {
      if (!isArtificialCustomEvent(event)) {
        throw new Error(`"useCustomEventListener" hook can only handle custom events`);
      }

      return callback(event.detail.value as GetEventValue<EventOfType<Operation>>);
    };

    document.addEventListener(name, handler);
    return () => document.removeEventListener(name, handler);
  }, [name, callback]);
};
